export default __webpack_public_path__ + "static/media/Peoples.5b728c2e.svg";